/* eslint-disable camelcase */
import { SourcingService } from 'api-clients/monolith';

type UpdateCampaignStatusProps = {
  sourcingPurchaseId: string;
  requestBody: {
    enabled: boolean | null;
    channel: string | null;
    reach_campaign_id: string | null;
  };
};

export function updateCampaignStatus(props: UpdateCampaignStatusProps) {
  return SourcingService.patchInternalApiSourcingSourcingPurchasesUpdateCampaignStatus(
    props.sourcingPurchaseId,
    props.requestBody,
  );
}
